export default "__VITE_ASSET__LwbCOt9V__"